import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class IpService {
	private http = inject(HttpClient);

	getIpAddress() {
		return this.http.get('https://api.ipify.org/?format=json');
	}
}
